import { atom, useAtom } from "jotai";

interface Response {
  isUseSorter: boolean;
  handleEnabledIsUseSorter: () => void;
  handleDisabledIsUseSorter: () => void;
}

const isUseSorterAtom = atom<boolean>(true);

export function useSorter(): Response {
  const [isUseSorter, setIsUseSorter] = useAtom(isUseSorterAtom);

  const handleEnabledIsUseSorter = () => {
    setIsUseSorter(true);
  };

  const handleDisabledIsUseSorter = () => {
    setIsUseSorter(false);
  };

  return {
    isUseSorter,
    handleEnabledIsUseSorter,
    handleDisabledIsUseSorter,
  };
}
